import { apiClient } from './api-client';

export interface TenantSettings {
  id: string;
  tenantId: string;
  timezone: string;
  language: string;
  currency: string;
  dateFormat: string;
  timeFormat: string;
  customerCodePrefix: string;
  assetNumberPrefix: string;
  createdAt: string;
  updatedAt: string;
}

export interface UpsertTenantSettingsPayload {
  timezone?: string;
  language?: string;
  currency?: string;
  dateFormat?: string;
  timeFormat?: string;
  customerCodePrefix?: string;
  assetNumberPrefix?: string;
}

export interface NumberingPrefixes {
  customerCodePrefix: string;
  assetNumberPrefix: string;
}

export const tenantSettingsService = {
  get: (): Promise<TenantSettings> =>
    apiClient.get<TenantSettings>('/settings/locale').then((r) => r.data),

  upsert: (payload: UpsertTenantSettingsPayload): Promise<TenantSettings> =>
    apiClient.patch<TenantSettings>('/settings/locale', payload).then((r) => r.data),

  /** Non-sensitive numbering prefixes — readable by any authenticated tenant
   * user (e.g. for Asset Number pre-fill during equipment registration). */
  getNumbering: (): Promise<NumberingPrefixes> =>
    apiClient.get<NumberingPrefixes>('/settings/numbering').then((r) => r.data),
};
